// Overgezet uit naslag/server/imports/api/calculations/CalculationPerAsset.ts.
import { round } from '../hulp.js';
import { deliveryTimePerPart, downtimePerAsset, maxKnowledgeMechanics, } from './StaticCalculationData.js';
import { ligtOpen } from '../data/magazijn.js';
import { Asset } from '../types/assets.js';
// Todo: Doesn't need export -> just for testing (when testing is done, remove the export)
export const downTimePerAssetMinimum = (asset, incident, malfunction, maintenance) => {
    const downTimeIncident = incident ? downtimePerAsset[asset].incident : 0;
    const downTimeMalfunction = malfunction ? downtimePerAsset[asset].storing : 0;
    const downTimeMaintenance = maintenance * downtimePerAsset[asset].onderhoud;
    return downTimeIncident + downTimeMalfunction + downTimeMaintenance;
};
const impactBonus = (asset, incident, malfunction, maintenance, impactBonusPresent) => {
    const downtime = downTimePerAssetMinimum(asset, incident, malfunction, maintenance);
    return impactBonusPresent ? downtime * 0.8 : downtime;
};
const mechanicImpactPercentage = (mechanicsKnowledge) => mechanicsKnowledge / maxKnowledgeMechanics;
const mechanicImpactPerAsset = (asset, incident, malfunction, maintenance, mechanicsKnowledge, impactBonusPresent) => {
    const bonus = impactBonus(asset, incident, malfunction, maintenance, impactBonusPresent);
    const impactPerAsset = bonus - (bonus * mechanicImpactPercentage(mechanicsKnowledge)) / 2;
    return round(impactPerAsset);
};
/**
 * De levertijd van de onderdelen die met spoed besteld worden, opgeteld.
 *
 * Niet zoals het origineel: dat zocht hier de onderdelen van één machine op in een eigen kopie
 * van het magazijn. Vroegen twee machines hetzelfde onderdeel en lag er één open, dan vond
 * elke machine dat ene onderdeel en kreeg geen van beide levertijd, terwijl het team wel
 * spoed betaalde. Welke onderdelen besteld worden, volgt nu uit `takenMetSpoed`.
 */
export const calculateShippingTime = (spoedOnderdelen) => spoedOnderdelen.reduce((totaal, part) => totaal + (deliveryTimePerPart[part] ?? 0), 0);
const storageBonusPerAsset = (specificAssetData, partsInStorage) => {
    let bonus = 0;
    specificAssetData.spareParts.forEach((part) => {
        // Niet in het origineel: een doos die nog onderweg is, telt niet (`ligtOpen`).
        if (partsInStorage.find((p) => ligtOpen(p) && p.part === part)) {
            bonus += 2;
        }
    });
    return bonus;
};
const downTimePerAssetPlusShipping = (asset, incident, malfunction, maintenance, mechanicsKnowledge, shippingTime, impactBonusPresent) => mechanicImpactPerAsset(asset, incident, malfunction, maintenance, mechanicsKnowledge, impactBonusPresent) + shippingTime;
export const downTimePerAsset = (asset, incident, malfunction, maintenance, mechanicsKnowledge, shippingTime, specificAssetData, partsInStorage, impactBonusPresent, sparePartBonusPresent) => {
    const downTime = downTimePerAssetPlusShipping(asset, incident, malfunction, maintenance, mechanicsKnowledge, shippingTime, impactBonusPresent);
    // TODO Klopt dit? (vraag uit het origineel)
    if (asset === Asset.vormmachineA || asset === Asset.vormmachineB)
        return downTime;
    if (sparePartBonusPresent) {
        const newDownTime = downTime - storageBonusPerAsset(specificAssetData, partsInStorage);
        return newDownTime < 0 ? 0 : newDownTime;
    }
    return downTime;
};
